// extracted by mini-css-extract-plugin
export default {"editButton":"EditButton_editButton__VkZ3r","editIcon":"EditButton_editIcon__Ul-Q2"};